import { DocumentCategory } from '@/app/api/types/redpim.types'
import { createElement, useEffect, useState } from 'react'

export function useSearch(query: string, lang: string) {
	const [loading, setLoading] = useState(false)
	const [products, setProducts] = useState([])
	const [resources, setResources] = useState<
		{
			itemPath: string
			itemType: string
			documentCategory: DocumentCategory
			metadataStorageName: string
			metadataStorageSize: string
		}[]
	>([])
	const [dt, setDt] = useState<{
		serialNumber: string
		partNumber: string
		family: string
		name: string
	} | null>(null)

	useEffect(() => {
		setProducts([])
		setResources([])
		setDt(null)
		const abortController = new AbortController()
		if (query.length < 3) {
			setLoading(false)
		}
		if (query.length >= 3) {
			setLoading(true)
			fetch(`/api/search?query=${query}&locale=${lang}`, {
				signal: abortController.signal,
			}).then(async (response) => {
				const data = await response.json()

				setResources(data.documents)

				setDt(data.dt)

				setProducts([
					...data.products.map((product: any) => ({
						id: product.pimId,
						title: product.name,
						bodyExcerpt:
							product.uspIntl[lang] || product.shortDescriptionIntl[lang],
						imageSrc: product.image?.url || '/images/driver.svg',
						url: `/products/series/${product.subCategory.slug}`,
					})),
					...data.items.map((item: any) => ({
						id: item.partnumber,
						title: item.model,
						// ⚠️In new PIM we do not retrieve category anymore but products (since category can be multiple). But get products from db for many items can be expensive.
						bodyExcerpt:
							item.shortDescriptionsIntl?.[lang] ||
							item.descriptionsIntl?.[lang] ||
							item.model,
						imageSrc: item.thumbnail
							? item.thumbnail +
								'/jcr:content/renditions/cq5dam.web.400.400.jpeg'
							: '/images/box.svg',
						url: `/products/${item.partnumber}`,
					})),
				])
				setLoading(false)
			})
		}

		return () => {
			abortController?.abort()
		}
	}, [query])

	return {
		loading,
		products,
		resources,
		dt,
	}
}
